cb.define([], function () {
  var PC_pc_tag_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      // 标签样式 显示文字还是 图片
      let tag_positionValue = 0; // 记录之前的选择状态
      const getlen = (str) => {
        return str.replace(/[\u0391-\uFFE5]/g, "aa").length;
      }
      const ChangeStyle = () => {
        let value = viewmodel.get('style').getValue();
        let val = (value == '1' ? true : false); //文字
        viewmodel.get('tag_bgcolor').setVisible(val);
        viewmodel.get('tag_fgcolor').setVisible(val);
        viewmodel.get('styleTemplate').setVisible(val);
        viewmodel.get('tag_image_url').setVisible(!val);
      }
      // 是否显示虚拟商品
      viewmodel.get('style').on('afterValueChange', function ({ value, oldvalue }) {
        ChangeStyle();
      })
      // 判断 适应范围 的值里面是否包含 管理端
      const diffScope = () => {
        const value = viewmodel.get('scope').getValue();
        let val = value.indexOf('1') >= 0
        viewmodel.get('tag_position').setVisible(val)
        tag_positionValue = viewmodel.get('tag_position').getValue() || tag_positionValue
        if (!val) {
          viewmodel.get('tag_position').setValue(null)
        } else {
          viewmodel.get('tag_position').setValue(tag_positionValue || 1)
        }
      }
      const diffColor = () => {
        let tag_fgcolor = viewmodel.get('tag_fgcolor').getValue()
        let tag_bgcolor = viewmodel.get('tag_bgcolor').getValue()
        viewmodel.get('styleTemplate').setValue({ font: tag_fgcolor, bg: tag_bgcolor })
      }
      viewmodel.get('tag_position').on('afterValueChange', (args) => {
        tag_positionValue = Number(args.value.value)
      })
      viewmodel.get('name').on('afterValueChange', (args) => {
        let _name = viewmodel.get('name').getValue();
        let _len = getlen(_name)
        if (_len > 16) {
          viewmodel.get('name').setState('err', "has-error")
          viewmodel.get('name').setState('msg', "标签名称超出限制")
          return false
        } else {
          viewmodel.get('name').setState('err', "")
          viewmodel.get('name').setState('msg', "")
        }
      })
      viewmodel.get('scope').on('afterValueChange', () => {
        diffScope()
      })
      viewmodel.get('tagClassName').on('afterValueChange', () => {
        viewmodel.get('scope').execute('afterValueChange', { value: viewmodel.get('scope').getValue() });
      })
      viewmodel.get('styleTemplate').on('afterValueChange', ({ value }) => {
        viewmodel.get('tag_fgcolor').setValue(value.font)
        viewmodel.get('tag_bgcolor').setValue(value.bg)
      })
      viewmodel.get('tag_fgcolor').on('afterValueChange', () => {
        diffColor()
      })
      viewmodel.get('tag_bgcolor').on('afterValueChange', () => {
        diffColor()
      })
      viewmodel.get('ruleScope').on('beforeValueChange', function (args) {
        if (args.oldValue.value == '2' && args.value.value != '2') {
          let ruleModel = viewmodel.getGridModel('rules');
          let rules = ruleModel.getRows();
          let skus = [];
          rules.length && rules.forEach((value, index) => {
            if (value['propertyType'] == '3') {
              skus.push(index);
            }
          })
          if (skus.length > 0) {
            cb.utils.confirm('范围设置为"商品"时将删除规则列表中的SKU属性，是否继续？', function () {
              viewmodel.getGridModel('rules').deleteRows(skus);
              viewmodel.get('ruleScope').setValue(args.value);
            })
            return false;
          }
        }
        return true;
      })
      viewmodel.getGridModel('rules').on('beforeCellValueChange', function (args) {
        let ruleModel = viewmodel.getGridModel('rules')
        if (args.cellName == 'propertyType' && args.value.value == '3') {
          if (viewmodel.get('ruleScope').getValue() != '2') {
            cb.utils.confirm('需要设置自动标签范围为"商品SKU"以支持SKU属性，是否继续？', function () {
              viewmodel.get('ruleScope').setValue('2');
              ruleModel.setCellValue(args.rowIndex, 'propertyType', args.value)
              ruleModel.setCellValue(args.rowIndex, 'property', null)
              ruleModel.setCellValue(args.rowIndex, 'caption', null)
            })
            return false;
          }
        }
        return true;
      })
      viewmodel.getGridModel('rules').on('afterCellValueChange', function (args) {
        let ruleModel = viewmodel.getGridModel('rules')
        if (args.cellName == 'propertyType') {
          ruleModel.setCellValue(args.rowIndex, 'property', null)
          ruleModel.setCellValue(args.rowIndex, 'caption', null)
        }
      })
      /************************************页面数据加载之后 -- start**********************************/
      viewmodel.on('afterLoadData', function () {
        let _tag_position = viewmodel.get('tag_position').getValue();
        if (_tag_position === '') {
          viewmodel.get('tag_position').setValue(0)
        }
        let mode = viewmodel.getParams().mode;
        if (mode != 'add') {
          diffColor()
        }
        diffScope()
        ChangeStyle();
      })
      /************************************页面数据加载之后 -- end  **********************************/
      viewmodel.on('beforeSave', (args) => {
        let data = JSON.parse(args.data.data);
        let _len = getlen(data.name)
        if (_len > 16) {
          // cb.utils.alert("标签名称超出限制", 'warning');
          viewmodel.get('name').setState('err', "has-error")
          viewmodel.get('name').setState('msg', "标签名称超出限制")
          return false
        } else {
          viewmodel.get('name').setState('err', "")
          viewmodel.get('name').setState('msg', "")
        }
        args.data.data = JSON.stringify(data);
      })

    }
  }
  try {
    module.exports = PC_pc_tag_VM_Extend;
  } catch (error) {}
  return PC_pc_tag_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_tag_VM.Extend.js